import styled from 'styled-components';

export const H3 = styled.h3`
  font-size: 2.4rem;
  font-weight: 600;
  color: #000;
`;



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/searchBox/styles/H3.js